// extracted by mini-css-extract-plugin
export default {"hover":"styles_hover__GzvN-"};